import { all, select, takeEvery, fork, call, put } from 'redux-saga/effects'

// action
import { couponActions } from '@redux/store/index'

// api
import { couponApi, ResType } from '@api'

// lib
import { Logger } from '@utils'

// type
import { Coupon, CouponCreationType, CouponType } from '@schemas'
import { CouponCombinedUpdateType, CouponStateType } from '@redux/types'

const apiGetCoupons = async (): Promise<ResType | undefined> => {
	const res: ResType | undefined = await couponApi.getCoupon()
	return res
}

const apiAddCoupon = async (body: CouponCreationType): Promise<ResType | undefined> => {
	const res: ResType | undefined = await couponApi.addCoupon({ body })
	return res
}

const apiUpdateCoupon = async (
	body: CouponCombinedUpdateType,
): Promise<ResType | undefined> => {
	const res: ResType | undefined = await couponApi.updateCoupon({
		params: {
			couponId: body.couponId,
		},
		body: {
			name: body.name,
			email: body.email,
			discountUsd: body.discountUsd,
			discountKrw: Number(body.discountKrw),
			quantity: body.quantity,
			expiredAt: body.expiredAt,
			useYn: body.useYn ? 1 : 0,
			unitUsd: body.unitUsd,
			unitKrw: Number(body.unitKrw),
		},
	})
	return res
}

const apiDeleteCoupon = async (
	body: CouponCombinedUpdateType,
): Promise<ResType | undefined> => {
	const res: ResType | undefined = await couponApi.deleteCoupon({
		params: {
			couponId: body.couponId,
		},
	})
	return res
}

function* triggerInitCoupon() {
	try {
		yield put(couponActions.COUPON_LIST_STATUS('loading'))
		const apiRes: ResType = yield call(apiGetCoupons)

		if (apiRes.status === 200) {
			const tempCouponList = apiRes.data[0] !== undefined ? (apiRes.data as any[]) : []
			const newCouponList = tempCouponList.map(
				aCoupon => new Coupon(aCoupon as CouponType),
			)
			yield put(couponActions.COUPON_LIST(newCouponList))

			if (apiRes.data.length > 0) {
				yield put(couponActions.COUPON_LIST_STATUS('ok'))
			} else {
				yield put(couponActions.COUPON_LIST_STATUS('empty'))
			}
		}
	} catch (error) {
		Logger.warn(error)
	}
}

function* updateCoupon() {
	try {
		const body: CouponStateType['updateCoupon'] = yield select(
			state => state.coupon.updateCoupon,
		)

		switch (body.iudFlag) {
			case 'I':
				yield call(apiAddCoupon, {
					name: body.name,
					email: body.email,
					discountUsd: body.discountUsd,
					discountKrw: Number(body.discountKrw),
					quantity: body.quantity,
					expiredAt: body.expiredAt,
					useYn: body.useYn ? 1 : 0,
					unitUsd: body.unitUsd,
					unitKrw: Number(body.unitKrw),
				} as CouponCreationType)
				break
			case 'U':
				yield call(apiUpdateCoupon, {
					couponId: body.couponId,
					name: body.name,
					email: body.email,
					discountUsd: body.discountUsd,
					discountKrw: body.discountKrw,
					quantity: body.quantity,
					expiredAt: body.expiredAt,
					useYn: body.useYn,
					unitUsd: body.unitUsd,
					unitKrw: body.unitKrw,
				} as CouponCombinedUpdateType)
				break
			case 'D':
				yield call(apiDeleteCoupon, {
					couponId: body.couponId,
				} as CouponCombinedUpdateType)
				break
		}

		yield put(couponActions.TRIGGER_INIT_COUPON_PAGE(true))
	} catch (error) {
		Logger.warn(error)
	}
}

function* mainSaga() {
	yield takeEvery(couponActions.TRIGGER_INIT_COUPON_PAGE, triggerInitCoupon)
	yield takeEvery(couponActions.UPDATE_COUPON, updateCoupon)
}

export default function* rootSaga() {
	yield all([fork(mainSaga)])
}
